/*
 * Cascade layer order: AIBI sits between components and utilities so that
 *   - AIBI's bundled component styles (e.g. yst-table-*) win over the host's
 *     ui-library copies, keeping AIBI components like the citations table
 *     visually consistent with how AIBI was built.
 *   - The host's Tailwind utilities (e.g. md:yst-flex-row) still win over
 *     AIBI's base utilities (e.g. yst-flex-col) so responsive overrides work.
 *   - `host-overrides` is the layer the client's own component CSS uses when
 *     it needs to fight ui-library defaults (display toggles on table parts,
 *     padding strips, etc.). Putting those rules in a layer instead of leaving
 *     them unlayered means a future second embedded app can be ordered against
 *     them deterministically rather than colliding via specificity wars.
 * Unlayered rules (further down in this file) keep their default top priority.
 */
@layer base, components, aibi, utilities, host-overrides;

/* AIBI's flat CSS, scoped into the `aibi` cascade layer. */
@import "../node_modules/@yoast/ai-insights-client/dist/ai-insights-client.css" layer(aibi);

/* Import main CSS including all components. */
@import "../node_modules/@yoast/ui-library/build/css/style.css";

/* Tailwind layers */
@tailwind base;
@tailwind components;
@tailwind utilities;


html, body {
	height: 100%;
	width: 100%;
	padding: 0;
	margin: 0;
	font-family: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
}

#root, #root > .yst-root {
	position: absolute;
	width: 100%;
	height: 100%;
}

.yst-modal__layout {
  position: relative;
}

.ReactModal__Body--open {
	overflow: hidden;
}

.auth_frame {
	height: 0;
	width: 0;
	position: absolute;
	left: -1000px;
	border: 0;
}
